/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

export class Count {
  total: number;
  stat: number;
  findings: number;
  isUnmonitored: boolean;
  // this property can be used to un-monitor work-list count.
  isUnmonitoredWhenInactive = false;

  constructor(
    total: number,
    stat: number,
    findings: number,
    isUnmonitored?: boolean,
    isUnmonitoredWhenInactive?: boolean
  ) {
    this.total = total;
    this.stat = stat;
    this.findings = findings;

    this.isUnmonitored = isUnmonitored;
    this.isUnmonitoredWhenInactive = isUnmonitoredWhenInactive;
  }
}
